function printMarsLogo () {
  /*

        o     o                       .oPYo.               8
        8b   d8                       8.                   8
        8`b d'8 .oPYo. oPYo. .oPYo.   `boo   `o  o' .oPYo. 8 .oPYo. oPYo. .oPYo. oPYo.
        8 `o' 8 .oooo8 8  `' Yb..     .P      `bd'  8    8 8 8    8 8  `' 8oooo8 8  `'
        8     8 8    8 8       'Yb.   8       d'`b  8    8 8 8    8 8     8.     8
        8     8 `YooP8 8     `YooP'   `YooP' o'  `o 8YooP' 8 `YooP' 8     `Yooo' 8
        ..::::..:.....:..:::::.....::::.....:..:::..8 ....:..:.....:..:::::.....:..::::
        ::::::::::::::::::::::::::::::::::::::::::::8 :::::::::::::::::::::::::::::::::
        ::::::::::::::::::::::::::::::::::::::::::::..:::::::::::::::::::::::::::::::::

        8                 o               o                                8       o
        8                 8                                                8
        8oPYo. o    o     8 .oPYo. odYo. o8 .oPYo. .oPYo. o   o   o .oPYo. 8  .o  o8
        8    8 8    8     8 .oooo8 8' `8  8 8    8 8    8 Y. .P. .P Yb..   8oP'    8
        8    8 8    8     8 8    8 8   8  8 8    8 8    8 `b.d'b.d'   'Yb. 8 `b.   8
        `YooP' `YooP8   oP' `YooP8 8   8  8 `YooP8 `YooP'  `Y' `Y'  `YooP' 8  `o.  8
        :.....::....8 ::...::.....:..::..:..:....8 :.....:::..::..:::.....:..::...:..
        :::::::::ooP'.::::::::::::::::::::::::ooP'.::::::::::::::::::::::::::::::::::
        :::::::::...::::::::::::::::::::::::::...::::::::::::::::::::::::::::::::::::

   */
}
console.log(`%c ${printMarsLogo}`, 'color: #c6ff00')
